import { UserCombobox } from '@/components'
import { USERS_COMBOBOX_QUERY } from '@/modules/users/queries'
import type { DropdownFilter } from '@/types/graphql'
import { useUser } from '@/utils/hooks'
import { useQuery } from '@apollo/client'
import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportField } from './export-field'

interface ExportUsersFieldProps {
  value: string[]
  label?: string
  error?: string | null
  dropdownPageName?: DropdownFilter
  wide?: boolean
  onChange(value: string[]): void
}

export const ExportUsersField: React.FC<ExportUsersFieldProps> = ({
  value,
  label,
  error,
  dropdownPageName,
  wide = true,
  onChange,
}) => {
  const translations = useTranslate({
    selectUsers: 'common.select-users',
    selectAll: 'common.select-all',
    clear: 'exports.form.clear-selection',
  })

  const me = useUser()
  const { data } = useQuery(USERS_COMBOBOX_QUERY, {
    variables: {
      includeSuperuser: me.isSuperuser,
      dropdown: dropdownPageName,
      filterLeaderGroup: false,
      filterSalaryResponsible: false,
    },
  })
  const allUserIds = (data?.allUsersList ?? []).map(user => user.id)
  const allSelected =
    allUserIds.length > 0 && allUserIds.every(id => value.includes(id))

  return (
    <ExportField
      label={label ?? translations.selectUsers}
      error={error}
      wide={wide}
      labelRight={
        <button
          type="button"
          className="text-xs font-semibold text-stone-500 hover:text-stone-900"
          onClick={() => onChange(allSelected ? [] : allUserIds)}
        >
          {allSelected ? translations.clear : translations.selectAll}
        </button>
      }
    >
      <UserCombobox
        mode="multiple"
        value={value}
        dropdownPageName={dropdownPageName}
        onChange={onChange}
      />
    </ExportField>
  )
}
